import React from 'react'
import {
  ShopContext,
  ModalManagerContext,
  FlashContext,
  useFlash,
  SetupAppContent,
  AppContentContext,
  SlerpMerchantContext,
  SetupSlerpMerchant,
  SetupSlerpShop,
  SetupModal,
  LoaderContext,
  SetupLoader,
  QueryParamsContext,
  SetupQueryParamsContext,
  CheckoutContextProvider,
  ConsumerCartProvider
} from 'shop/hooks'
import ThemeProvider from 'shop/theme'
import Theme from 'shop/theme/types'

interface ShopProps {
  theme?: Theme
  children?: React.ReactNode
}

export const GlobalContext = ({ theme, children }: ShopProps) => {
  return (
    <QueryParamsContext.Provider value={SetupQueryParamsContext()}>
      <ShopContext.Provider value={SetupSlerpShop()}>
        <FlashContext.Provider value={useFlash()}>
          <ModalManagerContext.Provider value={SetupModal()}>
            <AppContentContext.Provider value={SetupAppContent()}>
              <SlerpMerchantContext.Provider value={SetupSlerpMerchant()}>
                <ConsumerCartProvider>
                  <CheckoutContextProvider>
                    <LoaderContext.Provider value={SetupLoader()}>
                      <ThemeProvider theme={theme}>{children}</ThemeProvider>
                    </LoaderContext.Provider>
                  </CheckoutContextProvider>
                </ConsumerCartProvider>
              </SlerpMerchantContext.Provider>
            </AppContentContext.Provider>
          </ModalManagerContext.Provider>
        </FlashContext.Provider>
      </ShopContext.Provider>
    </QueryParamsContext.Provider>
  )
}

export default GlobalContext
